// @flow

const getConfiguration = (props: any) => {
    return {
        enableToolbarSearchField: false,
        enableRowExtension: true,
    }
}
export default getConfiguration;